import { motion } from "framer-motion";

const particles = [
  { left: "12%", top: "22%", size: 3, dur: 14, delay: 0 },
  { left: "78%", top: "18%", size: 2, dur: 18, delay: 2 },
  { left: "65%", top: "72%", size: 4, dur: 16, delay: 4 },
  { left: "22%", top: "68%", size: 2, dur: 20, delay: 1 },
  { left: "88%", top: "55%", size: 3, dur: 17, delay: 3 },
];

const AmbientParticles = () => {
  return (
    <div
      data-testid="ambient-particles"
      className="absolute inset-0 pointer-events-none overflow-hidden"
      aria-hidden="true"
    >
      {particles.map((p, i) => (
        <motion.span
          key={i}
          initial={{ opacity: 0 }}
          animate={{
            opacity: [0, 0.5, 0.5, 0],
            y: [0, -40, -80, -120],
            x: [0, 8, -8, 0],
          }}
          transition={{
            duration: p.dur,
            delay: p.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          style={{
            left: p.left,
            top: p.top,
            width: p.size,
            height: p.size,
          }}
          className="absolute rounded-full bg-gold-400 blur-[0.5px] shadow-[0_0_8px_rgba(212,175,55,0.6)]"
        />
      ))}
    </div>
  );
};

export default AmbientParticles;
